import { useLayout } from '@hana/shell';
import { CostList } from './CostList';
import { CostPhone } from './CostPhone';

/** Điện thoại dùng bản nhập phí hiện trường (Mint-Cost-Phone); các khổ khác giữ bảng Costing. */
export function CostRoute() {
  return useLayout() === 'phone' ? <CostPhone /> : <CostList />;
}
